import cryptoJs from 'crypto-js'

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY

export const encrypt = (text) => {
  const cipher = cryptoJs.AES.encrypt(text, SECRET_KEY)
  return cipher.toString()
}

// 복호화
export const decrypt = (encryptedText) => {
  if(encryptedText) {
    const decipher = cryptoJs.AES.decrypt(encryptedText, SECRET_KEY)
    return decipher.toString(cryptoJs.enc.Utf8)
  } else {
    return ''
  }
}
